/* eslint-disable max-classes-per-file */
import { CommonService } from '@Services/common.service'

export class MSummary {
    name: string

    serialCode: string

    price: any

    constructor(summary: any) {
        this.name =
            summary?.type === 'PART' ? summary?.component : summary?.name
        this.serialCode = summary?.serialCode
        this.price = summary?.itemSubscription?.totalAmount
            ? CommonService.currencyFormat(
                  summary?.itemSubscription?.totalAmount
              )
            : '$0'
    }
}

// statement section
export interface ITableTotalData {
    paymentSerial: string
    transaction: string
    paymentMethod: string
    amount: string
    discount: string
    balance: string
}

export class MInvoiceItem {
    serial: string

    period: string

    description: string

    date: string

    fee: string

    qty: string

    total: string

    constructor(invoice: any) {
        const { serialCode, issuedAt, description } = invoice?.item
        const { endedAt } = invoice?.item?.itemSubscription
        this.serial = serialCode || ' - '
        this.period = endedAt ? CommonService.dateFormat(endedAt) : ' - '
        this.description = description || ' - '
        this.date = issuedAt ? CommonService.dateFormat(issuedAt) : ' - '
        this.fee = CommonService.currencyFormat(invoice?.unitPrice)
        this.qty = invoice?.totalQty || 0
        this.total = CommonService.currencyFormat(invoice?.totalAmount)
    }
}

export class MInvoiceUser {
    username: string

    address: string

    gender: string

    constructor(user: any) {
        const {
            firstName,
            middleName,
            lastName,
            address,
            zipCode,
            state,
            country,
            city,
            gender,
        } = user?.profile
        const fullUsername = `${firstName}${
            middleName ? ` ${middleName}` : ''
        } ${lastName}`
        // address city state, city zipCode
        const userAddress = `${address}${city ? ` ${city}` : ''}${
            state ? ` ${state}` : ''
        }${country || zipCode ? ',' : ''}${country ? ` ${country}` : ''}${
            zipCode ? ` ${zipCode}` : ''
        }`
        this.username = fullUsername
        this.address = userAddress
        this.gender = gender
    }
}

export class MInvoicePayment {
    serial: string

    transaction: string

    method: string

    amount: string

    paidAmount: string

    balance: string

    constructor(payment: any) {
        this.serial = payment?.code || ' - '
        this.transaction = payment?.transactionId || ' - '
        this.method = payment?.transactionMethod || ' - '
        this.amount = CommonService.currencyFormat(payment?.totalAmount)
        this.paidAmount = CommonService.currencyFormat(payment?.totalPaidAmount)
        this.balance = CommonService.currencyFormat(
            +payment?.totalPaidAmount - +payment?.totalAmount
        )
    }
}

export class MInvoice {
    user: any

    items: MInvoiceItem[]

    payment: any

    code: string

    createdAt: string

    constructor(invoice: any) {
        this.user = new MInvoiceUser(invoice?.user)
        this.items = invoice?.items?.map(
            (item: MInvoiceItem) => new MInvoiceItem(item)
        )
        this.payment = new MInvoicePayment(invoice?.payment)
        this.code = invoice?.code
        this.createdAt = invoice?.createdAt
            ? CommonService.dateFormat(invoice?.createdAt)
            : ''
    }
}
// end statement

// receipt

export class MUserPayment extends MInvoicePayment {
    visa: string

    authorization: string

    code: string

    user: MInvoiceUser

    constructor(payment: any) {
        super(payment)
        this.visa = payment?.cardNumber || ' - '
        this.authorization = payment?.authorizerId || ' - '
        this.code = payment?.code
        this.user = new MInvoiceUser(payment?.user)
    }
}

// end receipt
